import React from 'react'
import { useDispatch } from 'react-redux'
import * as yup from 'yup'
import { FormikHelpers, FormikErrors } from 'formik'
import { useNewTranslation } from 'hooks'
import Modal, { UpdateTaxState } from './index'
import { CampaignState, updateTax } from 'state/campaigns'

interface UpdateTaxProps {
    campaign: CampaignState
    tax: number
    isTemplate: boolean
    onClose: () => void
}

const UpdateTax: React.FC<UpdateTaxProps> = ({ campaign, tax, isTemplate, onClose }) => {
    const [t] = useNewTranslation()
    const dispatch = useDispatch()

    const onSubmit = (value: number, setErrors: (errors: FormikErrors<UpdateTaxState>) => void) => {
        dispatch(
            updateTax({
                campaignUuid: campaign.uuid,
                tax: value,
                isTemplate,
            }),
        )
        onClose()
    }

    return (
        <Modal
            initialValues={{
                tax,
            }}
            validationSchema={yup.object({
                tax: yup
                    .number()
                    .nullable()
                    .required(t('modalWindow.editTaxRate.rateInputEmptyError'))
                    .integer(t('modalWindow.partipostFeeInput.overRangeSetting'))
                    .min(0, t('modalWindow.partipostFeeInput.overRangeSetting'))
                    .max(100, t('modalWindow.partipostFeeInput.overRangeSetting')),
            })}
            onSubmit={(values: UpdateTaxState, action: FormikHelpers<UpdateTaxState>) => {
                if (values.tax === undefined) return
                onSubmit(values.tax, action.setErrors)
            }}
            onClose={onClose}
            title={t('modalWindow.editTaxRate.modalTitle')}
            submitButtonText={t('button.confirm')}
            size="m"
        >
            <Modal.NumberInput
                name="tax"
                title={t('modalWindow.editTaxRate.rateInputTitle')}
                subtitle={t('modalWindow.editTaxRate.rateInputSubtext')}
                placeholder={t('modalWindow.partipostFeeInput.placeholder')}
                isRequired
                width="100%"
            />
        </Modal>
    )
}

export default UpdateTax
